import { useState, useCallback } from "react";
import { AuthFlow, AuthMethod } from "@interfaces";
import { useAuth } from "@contexts";

interface VerificationCodeHook {
  code: string;
  setCode: React.Dispatch<React.SetStateAction<string>>;
  verifyCode: (code: string) => Promise<boolean>;
  resendCode: (
    email: string,
    authMethod: AuthMethod,
    authFlow: AuthFlow,
  ) => Promise<void>;
}

export function useVerificationCode(): VerificationCodeHook {
  const [code, setCode] = useState<string>("");
  const { signIn, resendCode: contextResendCode } = useAuth();

  const verifyCode = useCallback(
    async (verificationCode: string): Promise<boolean> => {
      const success = await signIn(verificationCode);
      return success;
    },
    [signIn],
  );

  const resendCode = useCallback(
    async (email: string, authMethod: AuthMethod, authFlow: AuthFlow) => {
      await contextResendCode(email, authMethod, authFlow);
    },
    [contextResendCode],
  );

  return {
    code,
    setCode,
    verifyCode,
    resendCode,
  };
}
